import { getStore } from '../util';
import { ValidationError } from '../util/errors';

const getCreditDetailsByUser = async(userId) => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const url = `/api/admin/credit/${userId}`;
    const response =  await fetch(url, {
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       }
   });
   if (response.ok) {
       return response.json();
   }
   throw response;
};

const updateCredit = async(bookingId) => {
    const user = getStore('user');
    if (!user) {
        throw new ValidationError('token is not found');
    }
    const url = `/api/admin/credit/${bookingId}`;
    const response =  await fetch(url, {
        method: "POST",
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       }
   });
   if (response.ok) {
       return response.json();
   }
   throw response;
}

const getCreditList = async() => {
    const user = getStore('user');
    if (!user) {
      throw new ValidationError('token is not found');
    }
    const url = `/api/admin/credits`;
    const response =  await fetch(url, {
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       }
   });
   if (response.ok) {
       return response.json();
   }
   throw response;
}

const repayCredit = async(tenantId, amount) => {
    const user = getStore('user');
    if (!user) {
        throw new ValidationError('token is not found');
    }
    const url = `/api/admin/pay-credit/${tenantId}`;
    const response =  await fetch(url, {
        method: "PUT",
        headers: {
           'Content-Type': 'application/json',
           'x-access-token': user.accessToken
       },
       body: JSON.stringify({amount: amount})
   });
   if (response.ok) {
       return response.json();
   }
   throw response;
}

export { getCreditDetailsByUser, updateCredit, getCreditList, repayCredit }